
export default function print( state = [], action = {} ){

	switch( action.type ){
		case 'GET_PRINT_EMPLOYEE_EDIT':
			return action.print
		case 'GET_PRINT_ASSET':
			return action.print
		case 'GET_PRINT_TRAVEL':
			return action.print
		case 'GET_PRINT_LETTER':
			return action.print
		case 'GET_EXP_CERTIFICATE':
			return action.print
		case 'GET_EXIT_INTERVIEW':
			return action.print
		case 'GET_LETTER_SUMMARY_ANNUAL_LEAVE':
			return action.print
		default: return state;
	}
		
}




// WEBPACK FOOTER //
// ./src/store/reducers/prints/prints.reducer.js